var handle_array = ["2015-white-road-glide","2016-blue-build","2016-m-109","32-build","busa-build","chopper"];
 var productid_array = ["6817403043914","6818196324426","6818191933514","6818905751626","6818929606730","6818197831754"];
 var hide_price=1;
 var hide_ajaxaddtocart =1;
 var display_phone = 0;
 var phone_no='+16159000737';
 var display_call_for_price=0;
 var call_for_price_label = 'Request for price';
 var css_style_button='';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
 var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
 var enable_outofstock = 1;
 var price_selector='.product-single__price';
 var cart_selector='#AddToCart--template--14405268537418__main';
 var phone_no_label = 'Call for Pricing';
 var required_field='name,email,comment';
 var contact_form_heading='Price request for';
 var parent_selector='';
 var unavailable_label='Unavailable';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='no';
 var enable_cfp_for_all_products='no';
 var hide_cfp_btn_on_collection='yes';
 var hide_phone_no_on_collection='no';
 var enable_whatsapp = 0;
 var whatsapp_number = '';
 var whatsapp_message = 'Hi {store_name} I am interested in this product. {product_url}. Price please ?';
 var hide_whatsapp_button_on_collection = 0;
 var whatsapp_button_text ='Get price on Whatsapp';
 var whatsapp_button_background_color ='#000000';
 var whatsapp_button_text_color ='#ffffff';
 var whatsapp_css_style_button ='';
 var phoneno_css_style_button ='';